import { Injectable } from '@angular/core';
import { environment } from '@env/environment.prod';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { Observable } from 'rxjs';
import { confPaginated } from '@core/constants/paginacion.const';

@Injectable({
  providedIn: 'root'
})
export class ClienteService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/clientes';
  }

  getAll(): Observable<any> {
    const filterObject = {
      paginacion: confPaginated.quantity
    };
    return super.getAll(filterObject);
  }

  getAllCliente(): Observable<any> {
    // get
    return this.httpClient.get(this.baseUrl + '/all');
  }

  getByCI(ci: string): Observable<any> {
    console.log('service', ci);
    return this.httpClient.get(this.baseUrl + `/buscar/${ci}`);
  }
}
